module.exports = __webpack_public_path__ + "img/umbrella.98cb9bbd.png";